// extracted by mini-css-extract-plugin
export default {"selected-tracked-change":"markChanges_selected-tracked-change__7-zFB"};